import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import DefaultPopup, { IDefaultPopupCustomStyles } from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const PopupCustomStyles: IDefaultPopupCustomStyles = {
    popup: {},
    closePopup: {
        default: {
            top: `${24}px`,
            right: `${24}px`,
            position: 'fixed',
        },
        mobile: {
            top: `${16}px`,
            right: `${16}px`,
            position: 'absolute',
        },
    },
};

type TPopupPros = {
    popupIndent: number,
}

export const Popup = styled(DefaultPopup)<TPopupPros>`
    position: static;
    
    overflow-y: hidden;
    
    align-self: stretch;
    
    max-width: none;
    max-height: none;
    height: 100%;
    
    background: ${COLORS.BgSurface};
    border-radius: 0;
    
    margin: 0;
    
    @media (min-width: ${wideBreakpoints.mobile}) {
        height: ${($props) => `calc(100vh - ${2 * $props.popupIndent}px)`};
        border-radius: ${BorderRadius.OuterBlockRadius};
        
        margin: ${($props) => `${$props.popupIndent}px ${$props.popupIndent}px ${$props.popupIndent}px auto`};
    }
`;
